import { LitElement, html, svg } from 'lit';

export class IconTwitter24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Twitter logo</title><path fill="currentColor" d="M14.283 10.162 23.218 0H21.1l-7.758 8.824L7.147 0H0l9.37 13.343L0 24h2.117l8.193-9.318L16.853 24H24l-9.717-13.838Zm-2.9 3.299-.95-1.329L2.88 1.56h3.252l6.096 8.532.95 1.329 7.924 11.09h-3.253l-6.466-9.05Z"></path></svg>`; }
}
if (!customElements.get('f-icon-twitter24', IconTwitter24)) {
  customElements.define('f-icon-twitter24', IconTwitter24);
}